import ControlViewModel from '@/ViewModels/ControlViewModel';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import MultiSelectDropDownListViewModel from '@/ViewModels/Controls/MultiSelectDropDownListViewModel';
import ComponentManager from '@/Management/ComponentManager';

/**
 * Das ViewModel für die AssociationMultiDropDown
 */
export default class AssociationMultiDropDownViewModel extends ControlViewModel {

    /**
     * Die wählbaren Optionen
     */
    public multiSelectDropDownList: MultiSelectDropDownListViewModel;

    /**
     * Das ViewModel für den Link zum Erzeugen eines neuen Objekts
     */
    public linkCreate: LinkViewModel;

    /**
     * Das ViewModel für den Link zum Löschen des assoziierten Objekts
     */
    public linkDelete: LinkViewModel;

    /**
     * Trennt alle Verbindungen
     */
    public disconnectAll: Function;

    constructor(params: any) {
        super(params);
        this.multiSelectDropDownList = this.paramOrDefault(params.multiSelectDropDownList, null);
        this.linkCreate = this.paramOrDefault(params.linkCreate, null);
        this.linkDelete = this.paramOrDefault(params.linkDelete, null);
        this.disconnectAll = this.handlerOrDefault(params.disconnectAll);
    }
}

ComponentManager.setViewModel('AssociationMultiDropDownViewModel', AssociationMultiDropDownViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');